import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from './useToast';
import { useFormHandler } from './useFormHandler';
import { useAuth } from './useAuth';
import * as yup from 'yup';
import { useLogin } from '@/api/hooks/useLogin';

type LoginFormValues = {
  username: string;
  password: string;
};

const loginValidationSchema = yup.object({
  username: yup.string().required("Le nom d'utilisateur est obligatoire"),
  password: yup.string().required('Le mot de passe est obligatoire'),
});

export const useLoginForm = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [showTextPassword, setShowTextPassword] = useState(false);
  const { login: authLogin } = useAuth();
  const { logout } = useAuth();

  const { register, handleSubmit, errors } = useFormHandler<LoginFormValues>(
    loginValidationSchema,
  );

  const { mutate: login, isPending } = useLogin();

  const onSubmit = (data: LoginFormValues) => {
    login(
      {
        username: data.username,
        password: data.password,
      },
      {
        onSuccess: (response) => {
          authLogin(response.token.accessToken);
          localStorage.setItem('authToken', response.token.accessToken);
          navigate('/');
        },
        onError: (error) => {
          showToast(error?.message, 'error', {
            autoClose: 5000,
            position: 'top-right',
          });
        },
      },
    );
  };

  const togglePasswordVisibility = () => setShowTextPassword((prev) => !prev);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return {
    register,
    handleSubmit,
    errors,
    isPending,
    showTextPassword,
    togglePasswordVisibility,
    onSubmit,
    handleLogout,
  };
};
